import * as React from 'react';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import getIcon from '@/utils/getIcon';
import { NotificationItem, NotificationItemHeader, NotificationItemIcon, NotificationItemBody, NotificationItemTitle, NotificationItemText, NotificationItemFooter, NotificationItemDateTime } from './notifications';

export function NotificationsItem({ notification, notifications, setNotificationCount, notificationCount, setNotifications }) {
  const client = useClient();

  async function handleNotificationRead() {
    await client.mutate(['notifications', notification.id], {
      unread: false
    });

    setNotificationCount(notificationCount - 1);
    setNotifications(notifications.map(n => (n.id === notification.id ? { ...n, unread: false } : n)));
    window.location.replace(notification?.url);
  }

  return (
    <NotificationItem
      read={!notification.unread}
      onClick={handleNotificationRead}
    >
      <NotificationItemHeader>
        <NotificationItemIcon variant={notification.icon === 'warning' ? 'warning' : 'default'}>{getIcon(notification.icon)}</NotificationItemIcon>
      </NotificationItemHeader>

      <NotificationItemBody>
        <NotificationItemTitle>{notification.name}</NotificationItemTitle>
        <NotificationItemText>
          {notification.body && (
            <div>
              {notification.body.split('*f6$').map((n, i) => {
                if (n[0] == '>') {
                  return (
                    <a
                      href={notification?.url}
                      key={i}
                      onClick={e => {
                        e.preventDefault();
                        handleNotificationRead();
                      }}
                    >
                      {n.substring(1, n?.length)}
                    </a>
                  );
                } else {
                  return n;
                }
              })}
            </div>
          )}
        </NotificationItemText>
      </NotificationItemBody>

      <NotificationItemFooter>{notification['created-at'] && <NotificationItemDateTime>{moment(notification['created-at']).fromNow()}</NotificationItemDateTime>}</NotificationItemFooter>
    </NotificationItem>
  );
}
